import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PreQualificationData } from '../model/preQualificationData';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  private preQualData: PreQualificationData = new PreQualificationData();
  public preQualDetails = new BehaviorSubject<PreQualificationData>(this.preQualData);
  
  constructor() { }
  
}
